module.exports = __webpack_public_path__ + "img/组织动画奖品.d6c4b814.png";